import { MathHelper } from "@/Common/Helpers/MathHelper";
import { BloodGlucoseConcentrationUnit, SerumCreatinineConcentrationUnit } from "./Units";

export class LabConcentrationUnitConverter {
    public static glucoseConversionFactor = 0.0555; // 1 mg/dL = 0.0555 mmol/L
    public static creatinineSerumConversionFactor = 88.4; // 1 mg/100mL = 88.4 micromole/L

    public static convertBloodGlucoseConcentrationTo(from: BloodGlucoseConcentrationUnit, to: BloodGlucoseConcentrationUnit, value: number, numberOfDecimals?: number): number | null {
        if (!value || IsNullOrUndefined(from) || IsNullOrUndefined(to))
            return null;

        if (from === to)
            return value;

        let convertedValue = null;
        switch (from) {
            case BloodGlucoseConcentrationUnit.milligramPerDecilitre:
                convertedValue = value * this.glucoseConversionFactor;
                break;
            case BloodGlucoseConcentrationUnit.millimolesPerLitre:
                convertedValue = value / this.glucoseConversionFactor;
        }

        return numberOfDecimals ? MathHelper.roundToDecimals(convertedValue, numberOfDecimals) : convertedValue;
    }

    public static convertSerumCreatinineConcentrationTo(from: SerumCreatinineConcentrationUnit, to: SerumCreatinineConcentrationUnit, value: number, numberOfDecimals?: number): number | null {
        if (!value || IsNullOrUndefined(from) || IsNullOrUndefined(to))
            return null;

        if (from === to)
            return value;

        let convertedValue = null;
        switch (from) {
            case SerumCreatinineConcentrationUnit.micromolesPerLitre:
                convertedValue = value / this.creatinineSerumConversionFactor;
                break;
            case SerumCreatinineConcentrationUnit.milligramsPer100millilitre:
                convertedValue = value * this.creatinineSerumConversionFactor;
        }

        return numberOfDecimals ? MathHelper.roundToDecimals(convertedValue, numberOfDecimals) : convertedValue;
    }
}
